import React from 'react';
import { PropTypes } from 'prop-types';
import AppStack from './AppStack';
import AppText from './AppText';
import AppFlexbox from './AppFlexbox';
import AppImage from './AppImage';

const CustomSelectItem = ({
  image,
  color,
  label,
  description,
  noWrap,
  ...rest
}) => (
  <AppFlexbox style={{ gap: 5 }} {...rest}>
    {image && <AppImage height={30} src={image} width={30} />}

    <AppFlexbox style={{ gap: 10, alignItems: 'center', minWidth: 0 }}>
      {color && (
        <AppText
          style={{
            width: 15,
            height: 15,
            borderRadius: 15,
            backgroundColor: color,
            border: color === 'white' ? 'solid 1px black' : 'none'
          }}
        />
      )}
      <AppStack
        style={{
          gap: 0,
          minWidth: 0,
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <AppText size="sm" style={{ whiteSpace: noWrap ? 'nowrap' : 'normal' }}>
          {label}
        </AppText>
        {description && <AppText size="xs">{description}</AppText>}
      </AppStack>
    </AppFlexbox>
  </AppFlexbox>
);

CustomSelectItem.propTypes = {
  color: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  label: PropTypes.string,
  noWrap: PropTypes.bool
};

export default CustomSelectItem;
